import { render, staticRenderFns } from "./HouseCard.vue?vue&type=template&id=5c8f5e2e&scoped=true&"
import script from "./HouseCard.vue?vue&type=script&lang=js&"
export * from "./HouseCard.vue?vue&type=script&lang=js&"
import style0 from "./HouseCard.vue?vue&type=style&index=0&id=5c8f5e2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f5e2e",
  null
  
)

export default component.exports